import { client } from '../util/createRestApiClient';

const base = "msal-setting";
export default () => ({
    getMSALSettings: () => client.request({
        method: 'GET',
        url: base
    }),
    updateMSALSettings: (params) => client.request({
        method: 'PUT',
        url: base,
        data: {
            clientID: params.clientId,
            tenantID: params.tenantId,
            redirectUri: params.redirectUri,
            groups: params.groups // Nuevo campo
        }
      }),

}
);
